<div class="layout-col full">
  <app-job-browser
    class="flex"
    [jobKind]="JobKind.PRIMARY"
    (openJobDetail)="openSideDetail($event)"
  >
  </app-job-browser>
</div>
